import * as React from "react";

const CancerPage : React.FC = () => {
    return (
        <div className={"cancer"}>
            <div>
                <img src={"/images/header_cancer.png"} className={"header"} alt={"宮岡クリニック 癌の早期発見 - 通院で直せる痔の治療 宮岡クリニックでは、専門性を生かし、胃、大腸、肛門の治療に特に力を注いでいます。"}/>
            </div>
            <p>
                がんは早期発見で<strong>『治る病気』</strong>となりつつありますが、それに<strong>欠かせないのが検診・検査。</strong>しかし、とりわけ腸の検査などは、「痛い・苦しい・時間がない…」と、どうしても二の足を踏んでしまうのが現状です。
            </p>
            <p>
                患者さんが検査に対して不安を抱くのは当然。何でも気軽に相談してください。私たちは患者さんの不安を取り除き、<strong>苦痛を最大限に緩和する方法で検査を行います。</strong>
            </p>
            <p>
                院長は、数多くの臨床例＝患者の声に接してきました。多くのクリニックおよび病院と連携して治療を行っています。
            </p>
            <p>
                病気には、不安がつきもの。手術が必要となればなおさらです。患者さんが安心し、納得して治療に専念できる医療体制を提供する宮岡クリニックの存在は大病院とも連携し、これからの地域医療のありかたの一つのモデルとなることを目指しています。
            </p>
        </div>
    );
}

export default CancerPage;
